import React from 'react'
import styled from 'styled-components'
import Bg from "./images/popupHeader.png"
import Image from 'next/image'

const HeaderPopup = styled.div`
    background-image: url(${Bg.src});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 172px;

    @media screen and (max-width: 767px){
        height: 125px;
    }
`
const HeaderTxt = styled.p`
    margin: 0;
    color: #FFF;
    font-family: Roboto;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
    text-align: center;
    padding-top: 35px;

    @media screen and (max-width: 767px){
        font-size: 25px;
    }
`
const HeaderImg = styled.div`
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);

    @media screen and (max-width: 767px){
        top: 28%;
        width: 80px;
    }
`
const Tick = styled.div`
    position: absolute;
    top: 33%;
    left: 55%;
    transform: translate(-50%, -50%);

    @media screen and (max-width: 767px){
        top: 26%;
        left: 56%;
    }

`

export default function VerifyPopHeader(props) {
    return (
        <div>
            <HeaderPopup>
                <HeaderTxt>{props.text}</HeaderTxt>
                <HeaderImg><Image src={props.Img} alt="HeaderImg" /></HeaderImg>
                <Tick><Image src={props.TickImg} alt="TickImg" /></Tick>
            </HeaderPopup>
        </div>
    )
}
